export const prettyPrintPhoneNumber = (phoneNumber: string): string => {
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');

  const isFrenchNumber =
    (cleaned.startsWith('+33') && cleaned.length === 12) ||
    (cleaned.startsWith('0') && cleaned.length === 10);

  if (!isFrenchNumber) {
    return phoneNumber;
  }

  let normalized = cleaned;
  if (cleaned.startsWith('+33')) {
    normalized = '0' + cleaned.slice(3);
  }

  return normalized.replace(/(\d{2})(?=\d)/g, '$1 ');
};
